import { Directive, TemplateRef } from '@angular/core'

import { UiDataTableExpandedContext } from './ui-data-table.model'

@Directive({
    selector: '[uiTableExpanded]',
    standalone: true
})
export class UiTableExpandedDirective<T = unknown> {
    constructor(public template: TemplateRef<UiDataTableExpandedContext<T>>) {}

    static ngTemplateContextGuard<T>(
        _dir: UiTableExpandedDirective<T>,
        ctx: unknown
    ): ctx is UiDataTableExpandedContext<T> {
        return true
    }
}
